import { createAction } from '@reduxjs/toolkit';
import { AssetField, AssetFilterListItem } from '@Types';
import { SpatialLayer } from '@innovyze/lib-am-common';

export const getAssetFields = createAction<{
	systemType: string;
	assetType: string;
}>('asset/getAssetFields');
export const getAssetFieldsResolved = createAction<AssetField[]>(
	'asset/getAssetFieldsResolved',
);
export const getAssetFieldsRejected = createAction(
	'asset/getAssetFieldsRejected',
);

export const clearAssetFields = createAction('asset/clearAssetFields');

export const getAssetFilterList = createAction('asset/getAssetFilterList');
export const getAssetFilterListRejected = createAction(
	'asset/getAssetFilterListRejected',
);
export const getAssetFilterListResolved = createAction<AssetFilterListItem[]>(
	'asset/getAssetFilterListResolved',
);

export const getSpatialLayerList = createAction('Asset/getSpatialLayerList');

export const getSpatialLayerListResolved = createAction<SpatialLayer[]>(
	'Asset/getSpatialLayerListResolved',
);
export const getSpatialLayerListRejected = createAction(
	'Asset/getSpatialLayerListRejected',
);
